import {ProductService} from "../../source/product/product.service";

export async function loadProducts(context) {
  let products = ProductService.getAll();
  context.commit('setProducts', products)
}
